
import { mapGetters, mapActions } from "vuex";
import { formatData, arrayHelpers } from "../../constants/config.js";
export default {
    props: ['handleCollection', 'accessCatalog'],
    components: {
        vcLoading		    : () => import('../../components/pages/loading.vue'),
        productCollection   : () => import('../../components/product/product-collection.vue'),
        collectionSidebar   : () => import('../../components/product/collection-sidebar.vue'),
        vcFormatPrice       : () => import('../../components/product/format-price.vue'),
        sidebarProduct      : () => import('../../components/sidebar/product.vue'),
		vcDynamicLink	    : () => import('../../components/pages/dynamic-link.vue')
    },
    data() {
        return {
            isLoadingContent        : true,
            handle_collection	    : null,
            body_request            : null,
            page_products			: [],
            list_products			: [],
            
            access_catalog			: false,
            search_catalog			: "",
            email_catalog           : "",

            sort_products			: { id: "default", value: 'best-selling', label: "Default" },
            
            active_scroll_paginated	: false,
            show_scroll_loading     : false,
            execute_find_products   : false,
            position_grid_prdocuts	: 0,
            
            product_data_filter		: {
                price: {
                    field: 'price',
                    values: {
                        min_price: 0,
                        max_price: 0
                    }
                }
            },
            original_filter_price	: {
                min_price: 0,
                max_price: 0
            },
            
            list_filters			: [],
            
            current_page			: 1,
            per_page				: 48,
            total_pages				: 1,
            
            modal_product			: null,
            default_images          : [
            { width: 180, alt: "", src: '/images/products/product-default_320.webp' },
            { width: 320, alt: "", src: '/images/products/product-default_320.webp' }
            ]
        };
    },
    async mounted() {
        this.sort_products = this.getOptionsSort[0];

        // this.$root.$on("add-filter", this.addFilter);
        // this.$root.$on("remove-filter", this.removeFilter);

        if( !this.handleCollection && !this.$route.params.handle ){
            
            this.handle_collection = null;
        }
        else if( this.handleCollection && !this.$route.params.handle ){
            
            this.handle_collection = this.handleCollection;
        }
        else{
            
            this.handle_collection = this.$route.params.handle;
        }
        this.resetCollection();
        
        if( this.handle_collection === 'price-catalog' ){
            
            this.access_catalog = false;
            this.$root.$emit("change-access-catalog", false);
        }
        else{
            this.access_catalog = this.accessCatalog;
        }
        window.scrollTo(0, 0);
        if( this.getHandleCollection && this.getHandleCollection != 'price-catalog' ){
            
            await this.requestCollection();
        }


        this.position_grid_prdocuts = document.getElementById("product-grid")?.getBoundingClientRect().top;
        window.addEventListener('load', (event) => {
            
            this.position_grid_prdocuts = document.getElementById("product-grid")?.getBoundingClientRect().top;
        });
        window.addEventListener('scroll', async (event) => {

            let num_product_columns     = window.innerWidth > 1150 ? 4 : window.innerWidth <= 1150 && window.innerWidth > 768 ? 3 : window.innerWidth <= 768 && window.innerWidth > 575 ? 2 : 1;
            let mid_height_product_page = ( ( this.per_page / num_product_columns ) / 3 ) * 450;
            if( document.getElementById("product-grid") && this.getActiveScrollPaginated === true && window.scrollY >= this.position_grid_prdocuts && ( ( document.getElementById("product-grid")?.offsetHeight - mid_height_product_page ) <= window.scrollY && ( document.getElementById("product-grid")?.offsetHeight - mid_height_product_page ) > 0 ) ) {
                
                this.active_scroll_paginated = false;
                await this.loadMorePageProducts();
            }
        });
    },
    computed: {
        ...mapGetters({
            getterTranslates        : 'getterTranslates',
            getterStoreLang	        : 'getterStoreLang',
            getterCollection		: "getterCollection",
            getterFiltersCollection	: "getterFiltersCollection",
        }),
        getLoadingContent(){
            return this.isLoadingContent;
        },
        getOptionsSort(){
            return [
            { id: "default"		, value: 'best-selling'	, label: this.getterTranslates.components.product.collection_content.filters.sort.options.default[this.getterStoreLang] },
            { id: "price-1"		, value: 'price-asc'	, label: this.getterTranslates.components.product.collection_content.filters.sort.options.price_asc[this.getterStoreLang] },
            { id: "price-2"		, value: 'price-desc'	, label: this.getterTranslates.components.product.collection_content.filters.sort.options.price_desc[this.getterStoreLang]},
            { id: "date"		, value: 'created'		, label: this.getterTranslates.components.product.collection_content.filters.sort.options.new[this.getterStoreLang] }
            ];
        },
        getAccessCatalog(){
            return this.access_catalog;
        },
        getHandleCollection(){
            return this.handle_collection;
        },
        getQueryFilterPrice() { 
            let query_price = this.$route.query.price ? decodeURI(this.$route.query.price).split('-') : null;
            return query_price != null ? { min_price: parseInt(query_price[0]), max_price: parseInt(query_price[1]) } : null;
        },
        getQueryFilterBrands() { 
            return this.$route.query.brands ? decodeURI(this.$route.query.brands).split(',') : [];
        },
        getQueryFilterProductCategories() { 
            return this.$route.query.product_categories ? decodeURI(this.$route.query.product_categories).split(',') : [];
        },
        getQueryFilterProductOptions() { 
            return this.$route.query.product_options ? decodeURI(this.$route.query.product_options).split(',') : [];
        },
        getQueryFilterTags() { 
            return this.$route.query.tags ? decodeURI(this.$route.query.tags).split(',') : [];
        },
        getQueryFilterSearch() { 
            return this.$route.query.search || null;
        },
        getListProducts(){
            return this.list_products;
        },
        getListFilters(){
            return this.list_filters;
        },
        getActiveScrollPaginated(){
            return this.active_scroll_paginated;
        },
        getExecuteFindProducts(){
            return this.execute_find_products;
        }
    },
    methods: {
        ...mapActions({
            resetCollection			: 'resetCollection',
            getCollection			: 'getCollection',
            updateFilterCollection	: 'updateFilterCollection'
        }),
        formatCurrency(price, totalAmount = null){
            
            return formatData.currency(price, totalAmount);
        },
        async requestCollection() {
            
            this.body_request = {
                handle_collection	: this.getHandleCollection,
                options             : {
                    paginated   : {
                        page    : this.current_page,
                        per_page: this.per_page,
                    },
                    sort        : { 
                        sort_category   : 1, 
                        default_sort    : 1 
                    }
                },
                get_filters         : true,
                filters             : {
                    price				: this.getQueryFilterPrice,
                    search				: this.getQueryFilterSearch,
                    brands				: this.getQueryFilterBrands,
                    product_categories	: this.getQueryFilterProductCategories,
                    product_options		: this.getQueryFilterProductOptions,
                    tags				: this.getQueryFilterTags
                },
                catalog             : null
            };
            if( this.$route.query.catalog ){
                this.body_request.catalog = {
                    email   : this.email_catalog,
                    id      : this.$route.query.catalog
                };
            }
            await this.getCollection( this.body_request ).then( (result_collection) => {
                
                this.isLoadingContent = null;
                if( this.getterCollection ){
                    this.total_pages = this.getterCollection.paginated_products.total_pages;
                    this.list_products = this.getterCollection.paginated_products.documents;
                    this.active_scroll_paginated = true;
                    this.current_page = 1;
                    if( this.getHandleCollection === 'price-catalog' ){
                        
                        this.access_catalog = this.$route.query.catalog ? this.getterCollection.access_catalog : false;
                        this.$root.$emit("change-access-catalog",  this.access_catalog);
                        this.$root.$emit("init-count-down", this.getterCollection.data_catalog?.time_left || 0);
                    }
                    // if( this.getterCollection.paginated_products.filters ){
                    //     // this.addFilterQuery();
                    // }
                }
            });
        },
        async nextPageProducts( page ){

            this.body_request.options.paginated.page    = page;
            this.body_request.get_filters               = false;
            let result_products = [];
            return await this.getCollection( this.body_request ).then( (result_collection) => {
                
                this.isLoadingContent = null;
                if( this.getterCollection ){
                    
                    result_products 				= this.getterCollection.paginated_products.documents;
                    
                    this.show_scroll_loading 		= false;
                    
                }
                return result_products;
            }).catch( (error) => {
                
                this.active_scroll_paginated = false;
                this.show_scroll_loading 	= false;
                return result_products;
            });
        },
        addFilterQuery(){
            
            let main_filters = ['product-types', 'brands', 'variants', 'tags'];
            
            for (const [key_item, value_item] of Object.entries( this.$route.query )) {
                let index_main_filter = main_filters.findIndex( (item) => key_item.indexOf( item ) >= 0 );
                if( key_item === 'price' ){
                    this.product_data_filter['price'].values = {
                        min_price: parseFloat( decodeURI(value_item).split("-")[0] ),
                        max_price: parseFloat( decodeURI(value_item).split("-")[1] )
                    };
                    this.list_filters.push({ id: 'filter-price', name: 'Price', handle: 'price', sub_filter: null, value: [ parseFloat( decodeURI(value_item).split("-")[0] ), parseFloat( decodeURI(value_item).split("-")[1] )] });
                }
                else if( index_main_filter > 0 && index_main_filter <= 1 && this.product_data_filter[main_filters[index_main_filter]] ){
                    
                    this.product_data_filter[main_filters[index_main_filter]].values[value_item].checked = true;
                    let exist_filter = this.product_data_filter[main_filters[index_main_filter]];
                    for (const item_filter of value_item.split(',')) {
                        
                        if( exist_filter.values[item_filter] ){
                            
                            this.list_filters.push({ 
                                id: `filter-${ main_filters[index_main_filter] }`, 
                                name: exist_filter.name, 
                                handle: exist_filter.handle, 
                                sub_filter: null, 
                                value: { name: exist_filter.values[item_filter].name, handle: exist_filter.values[item_filter].handle, checked: exist_filter.values[item_filter].checked } 
                            });
                        }
                    }
                }
                else if( index_main_filter > 1 && index_main_filter <= 3 && this.product_data_filter[main_filters[index_main_filter]]?.values[key_item.replace(`${ main_filters[index_main_filter] }-`, '')] ){
                    
                    this.product_data_filter[main_filters[index_main_filter]].values[key_item.replace(`${ main_filters[index_main_filter] }-`, '')].values[value_item].checked = true;
                    let exist_filter = this.product_data_filter[main_filters[index_main_filter]];
                    let exist_sub_filter = exist_filter.values[key_item.replace(`${ main_filters[index_main_filter] }-`, '')];
                    for (const item_filter of value_item.split(',')) {
                        
                        if( exist_filter.values[item_filter] ){
                            
                            this.list_filters.push({ 
                                id: `filter-${ main_filters[index_main_filter] }`, 
                                name: exist_filter.name, 
                                handle: exist_filter.handle, 
                                sub_filter: { name: exist_sub_filter.name, handle: exist_sub_filter.handle }, 
                                value: { name: exist_sub_filter.values[item_filter].name, handle: exist_sub_filter.values[item_filter].handle, checked: exist_sub_filter.values[item_filter].checked } 
                            });
                        }
                    }
                }
            }
            this.excecuteFilter();
            this.current_page = 1;
        },
        async onChangeSort() {
            
            this.current_page 		= 1
            await this.excecuteFilter();
        },
        formatFilter(){
            
            return ( this.getterCollection.paginated_products.filters != null && this.getterCollection.paginated_products.filters.selected != null ?  this.getterCollection.paginated_products.filters.selected : []).reduce( (previous_item_filter, current_item_filter) => {
                
                let data_filter = {
                    name    : current_item_filter.name,
                    handle  : current_item_filter.handle,
                    field   : current_item_filter.field,
                    show    : current_item_filter.show,
                    values  : []
                };

                if( current_item_filter?.handle === 'price' ){
                    data_filter.values = {
                        min_price: current_item_filter.values?.min_price,
                        max_price: current_item_filter.values?.max_price,
                    };
                    previous_item_filter.original_filter_price = {
                        min_price: current_item_filter.values?.min_price,
                        max_price: current_item_filter.values?.max_price,
                    };
                }
                else if( !['variants', 'tags'].includes( current_item_filter.handle ) ){
                    
                    data_filter.values = current_item_filter.values.reduce( (previous_item, current_item) => { previous_item[current_item.handle] = current_item; return previous_item; }, {});
                }
                else{
                    
                    data_filter.values = current_item_filter.values.reduce( (previous_item_subfilter, current_item_subfilter) => { 
                        
                        previous_item_subfilter[current_item_subfilter.handle] 			= current_item_subfilter;
                        previous_item_subfilter[current_item_subfilter.handle].values 	= current_item_subfilter.values.reduce( (previous_item, current_item) => { previous_item[current_item.handle] = current_item; return previous_item; }, {});
                        return previous_item_subfilter; 
                    }, {});
                }
                
                previous_item_filter.all_filters[current_item_filter.handle]	= JSON.parse( JSON.stringify( data_filter ) );
                previous_item_filter.select_filters[current_item_filter.handle] = JSON.parse( JSON.stringify( data_filter ) );
                
                if( current_item_filter.handle != 'price' && !['variants', 'tags'].includes( current_item_filter.handle ) ){
                    
                    previous_item_filter.select_filters[current_item_filter.handle].values 	= {};
                }
                
                return previous_item_filter;
                
            }, { all_filters: {}, select_filters: {}, original_filter_price: null });
        },
        formatSidebarFilters( data_filters ){
            
            data_filters = Object.entries( data_filters ).map( ([key_item_filter, value_item_filter]) => {
                
                let new_item_filter = value_item_filter;
                
                if( key_item_filter != 'price' ){
                    
                    new_item_filter.values = Object.entries( new_item_filter.values ).map( ([key_item_subfilter, value_item_subfilter]) => {
                        
                        let new_item_subfilter = value_item_subfilter;
                        
                        if( ['variants', 'tags'].includes( key_item_filter ) ){
                            
                            new_item_subfilter.values = Object.entries( new_item_subfilter.values ).map( ([key_item_value, value_item_value]) => {
                                
                                return value_item_value;
                            }, []);
                            new_item_subfilter.count = JSON.parse( JSON.stringify( new_item_subfilter.values ) ).reduce( (previous_item, current_item) => {
                                
                                previous_item.isShow += current_item.show ? 1 : 0;
                                previous_item.isChecked += current_item.checked ? 1 : 0;
                                return previous_item;
                            }, { isShow: 0, isChecked: 0 });
                        }
                        return new_item_subfilter;
                    });
                    if( !['variants', 'tags'].includes( key_item_filter ) ){
                        
                        new_item_filter.count = JSON.parse( JSON.stringify( new_item_filter.values ) ).reduce( (previous_item, current_item) => {
                            
                            previous_item.isShow += current_item.show ? 1 : 0;
                            previous_item.isChecked += current_item.checked ? 1 : 0;
                            return previous_item;
                        }, { isShow: 0, isChecked: 0 });
                    }
                }
                return new_item_filter;
            });
            return data_filters;
        },
        async removeFilter(item_selected) {
            
            this.list_filters.splice( this.list_filters.findIndex( (item) => item.handle === "price" || ( item.handle === item_selected.handle && item.value.handle === item_selected.value.handle ) ), 1 );
            
            if( !item_selected.sub_filter && item_selected.handle != 'price' ){
                
                this.product_data_filter[item_selected.handle].values[item_selected.value.handle].checked = false;
            }
            else if( item_selected.handle != 'price' ){
                
                this.product_data_filter[item_selected.handle].values[item_selected.sub_filter.handle].values[item_selected.value.handle].checked = false;
            }
            else if( item_selected.handle === 'price' ){
                
                this.product_data_filter[item_selected.handle].values = {
                    min_price: this.original_filter_price?.min_price,
                    max_price: this.original_filter_price?.max_price
                };
            }
            await this.excecuteFilter();
            this.current_page = 1;
        },
        async removeAllFilters() {
            
            for (const item_filter of this.list_filters) {
                
                if( !item_filter.sub_filter && item_filter.handle != 'price' ){
                    
                    this.product_data_filter[item_filter.handle].values[item_filter.value.handle].checked = false;
                }
                else if( item_filter.handle != 'price' ){
                    
                    this.product_data_filter[item_filter.handle].values[item_filter.sub_filter.handle].values[item_filter.value.handle].checked = false;
                }
                else if( item_filter.handle === 'price' ){
                    
                    this.product_data_filter[item_filter.handle].values = {
                        min_price: this.original_filter_price?.min_price,
                        max_price: this.original_filter_price?.max_price
                    };
                }
            }
            this.list_filters = [];
            await this.excecuteFilter();
            this.current_page = 1;
        },
        async addFilter(item_selected) {
            
            this.list_filters.push( item_selected );
            
            if( !item_selected.sub_filter && item_selected.handle != 'price' ){
                
                this.product_data_filter[item_selected.handle].values[item_selected.value.handle].checked = true;
            }
            else if( item_selected.handle != 'price' ){
                
                this.product_data_filter[item_selected.handle].values[item_selected.sub_filter.handle].values[item_selected.value.handle].checked = true;
            }
            else if( item_selected.handle === 'price' ){
                this.product_data_filter[item_selected.handle].values = {
                    min_price: item_selected.value[0],
                    max_price: item_selected.value[1]
                };
            }
            await this.excecuteFilter();
            this.current_page = 1;
        },
        updateShowFilterSimpleValues( item_product , typeFilter, reset_show_filter ){
            
            const main_filter = this.product_data_filter[typeFilter];
            
            for (const [key_variant_filter, value_variant_filter] of Object.entries( main_filter.values ) ) {
                
                if( reset_show_filter || !item_product || main_filter.values[key_variant_filter].checked ) {
                    
                    this.product_data_filter[typeFilter].values[key_variant_filter].show = true;
                }
                else{
                    
                    this.product_data_filter[typeFilter].values[key_variant_filter].show = item_product[main_filter.field].findIndex( (item) => item.handle === main_filter.values[key_variant_filter].handle ) >= 0;
                }
            }
        },
        updateShowFilterComplexValues(item_product, typeFilter, reset_show_filter){
            
            const main_filter = this.product_data_filter[typeFilter];
            
            for (const [key_variant_filter, value_variant_filter] of Object.entries( main_filter.values ) ) {
                
                for (const [key_variant_value, value_variant_value] of Object.entries( value_variant_filter.values )) {
                    
                    if( reset_show_filter || !item_product || main_filter.values[key_variant_filter].values[key_variant_value].checked ) {
                        
                        this.product_data_filter[typeFilter].values[key_variant_filter].values[key_variant_value].show = true;
                    }
                    else{
                        
                        this.product_data_filter[typeFilter].values[key_variant_filter].values[key_variant_value].show = item_product[main_filter.field].findIndex( (item_value) => item_value.handle === key_variant_value ) >= 0;
                    }
                }
            }
        },
        updateFilterData( item_product, reset_show_filter = false ){
            
            this.updateShowFilterSimpleValues(item_product, 	'brands', 			reset_show_filter);
            this.updateShowFilterSimpleValues(item_product, 	'product-types', 	reset_show_filter);
            this.updateShowFilterComplexValues(item_product, 	'variants', 		reset_show_filter);
            this.updateShowFilterComplexValues(item_product, 	'tags', 			reset_show_filter);
        },
        filterProductSearch( item_product ){
            
            return new RegExp(this.search_catalog, 'i').test( item_product.search_field );
        },
        // filterProductPrice( item_product ){
        //     console.log(item_product, 'item_product')
        //     return item_product.filters[this.product_data_filter['price'].field].min_price >= this.product_data_filter['price'].values.min_price && item_product.filters[this.product_data_filter['price'].field].max_price <= this.product_data_filter['price'].values.max_price;
        // },
        filterProductPrice(item_product) {
            try {
                // Validar que existan todas las propiedades necesarias
                if (!item_product?.filters || 
                    !this.product_data_filter?.price?.field ||
                    !item_product.filters[this.product_data_filter['price'].field] ||
                    !this.product_data_filter?.price?.values) {
                    return false;
                }

                const productPrice = item_product.filters[this.product_data_filter['price'].field];
                const filterPrice = this.product_data_filter['price'].values;

                return productPrice?.min_price >= filterPrice?.min_price && 
                    productPrice?.max_price <= filterPrice?.max_price;
            } catch (error) {
                console.warn('Error filtering product price:', error);
                return false;
            }
        },
        filterSimpleProduct( item_product, filterType ){
            
            let filterSimple = true;
            for (const [key_item_filter, value_item_filter] of Object.entries( this.product_data_filter[filterType].values )) {
                
                if( value_item_filter.checked ){
                    
                    filterSimple = filterSimple && item_product.filters[this.product_data_filter[filterType].field].name === value_item_filter.name;
                }
            }
            return filterSimple;
        },
        filterComplexProduct( item_product, filterType ){
            
            let filterComplex = true;
            for (const [key_item_filter, value_item_filter] of Object.entries( this.product_data_filter[filterType].values )) {
                
                for (const [key_item_value, value_item_value] of Object.entries( value_item_filter.values )) {
                    
                    if( value_item_value.checked ){
                        
                        filterComplex = filterComplex && item_product.filters[this.product_data_filter[filterType].field].findIndex( (item) => item.handle === key_item_value ) >= 0;
                    }
                }
            }
            return filterComplex;
        },
        async excecuteFilter(){
            this.is_loading_page = true;
        
            // Actualizar body_request con los filtros actuales
            this.body_request.filters = {
                ...this.body_request.filters,
                search: this.search_catalog || null
            };
            
            this.body_request.options.paginated.page = 1;
            
            // Realizar nueva petición al servidor con los filtros actualizados
            await this.getCollection(this.body_request).then((result_collection) => {
                if(this.getterCollection) {
                    this.list_products = this.getterCollection.paginated_products.documents;
                    this.total_pages = this.getterCollection.paginated_products.total_pages;
                    this.current_page = 1;
                    this.active_scroll_paginated = true;
                }
                this.is_loading_page = null;
            });
        },
        async searchCatalog(event){
            if( !event.keyCode || event.keyCode === 13 ){
                this.current_page = 1;
                await this.excecuteFilter();
            }
        },
        async cleanSearchCatalog(){
            this.search_catalog = "";
            this.current_page = 1;
            await this.excecuteFilter();
        },
        async loadMorePageProducts(){
            
            if( this.current_page < this.total_pages ){
                
                this.show_scroll_loading     = true;
                let result_products = await this.nextPageProducts( this.current_page + 1 );
                for (const item_product of result_products) {
                    
                    this.list_products.push( item_product );
                }
                if( result_products.length > 0 ){

                    setTimeout( () => {
                        if( this.current_page <= this.total_pages ){

                            this.active_scroll_paginated = true;
                        }
                        else{
                            
                            this.active_scroll_paginated = false;
                        }
                    }, 1000);
                }
                this.current_page++;
            }
        },
        async requestAccessCatalog() {
            
            await this.requestCollection();
        }
    }
};
